// public/scripts/register-company.js
import { http, API_BASE } from "./api/http.js";
import { showSpinner, hideSpinner } from "../app/components/spinner.js";
import { showSuccess, showError } from "../app/components/toast.js";

console.log("[register-company] script loaded");
console.log("[register-company] Using API_BASE:", API_BASE);

// ─────────────────────────────────────────────
// Wait until DOM is fully parsed
// ─────────────────────────────────────────────
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initRegisterCompanyForm);
} else {
	initRegisterCompanyForm();
}

function initRegisterCompanyForm() {
	console.log("[register-company] Initializing form...");

	const form = document.getElementById("registerCompanyForm");
	const errorsEl = document.getElementById("formErrors");
	let submitBtn = null;

	if (form) {
		submitBtn = form.querySelector("button[type='submit']") || form.querySelector("button");
	}

	if (!form || !submitBtn) {
		console.warn("⚠️ Form or submit button missing");
		console.debug("[debug] current DOM snippet:", document.body.innerHTML.slice(0, 300));
		return;
	}

	console.log("✅ Form ready and handler attached");

	// Inline error helper
	const setErrors = (messages = []) => {
		if (!errorsEl) return;
		errorsEl.innerHTML = messages.map((msg) => `<div>- ${msg}</div>`).join("");
	};

	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		e.stopPropagation();
		console.log("[probe] submit fired");

		const companyName = form.companyName?.value?.trim() || "";
		const website = form.website?.value?.trim() || "";
		const adminName = form.adminName?.value?.trim() || "";
		const email = form.adminEmail?.value?.trim() || "";
		const phone = form.adminPhone?.value?.trim() || "";
		const password = form.password?.value?.trim() || "";
		const confirmPassword = form.confirmPassword?.value?.trim() || "";

		const errors = [];

		if (companyName.length < 2) errors.push("Company name must be at least 2 characters long.");
		if (adminName.length < 2) errors.push("Contact name must be at least 2 characters long.");
		if (!/^\S+@\S+\.\S+$/.test(email)) errors.push("Please enter a valid work email.");
		if (!/^[0-9]{10,15}$/.test(phone)) errors.push("Phone number must contain 10–15 digits.");
		if (password.length < 6) errors.push("Password must be at least 6 characters long.");
		if (!confirmPassword) errors.push("Confirm password is required.");
		if (password !== confirmPassword) errors.push("Passwords do not match.");
		if (website && !/^https?:\/\/.+\..+/.test(website)) errors.push("Please enter a valid website URL (https://...).");

		if (errors.length) {
			setErrors(errors);
			showError(errors[0]);
			return;
		}

		try {
			setErrors();
			showSpinner(submitBtn, "Creating account...");

			const payload = {
				name: companyName,
				email,
				password,
				phone,
				role: "company",
				metadata: { contactName: adminName, website: website || null },
			};

			const res = await http.post("/auth/register", payload);
			const msg = res?.message || "Company account created successfully.";

			showSuccess(msg);
			form.reset();
			setTimeout(() => (window.location.href = "/app/pages/login.html"), 1500);
		} catch (err) {
			console.error("❌ API error", err);
			const message = err?.message || "Unable to create company account.";
			showError(message);
			setErrors([message]);
		} finally {
			hideSpinner(submitBtn);
		}
	});
}
